import { tables } from '@/utils/tableProperties';
import agencyDashboardAPI from '@/utils/api/agencyDashboard';
import { genericError, genericSuccess } from '@/utils/alerts.service';

export const ourPublicProfilesLeads = {
  namespaced: true,
  state: {
    // entries of the table
    rows: [],

    // search bar
    query: '',

    // these will be columns in the table
    columns: tables.leads.fields,

    filters: {
      name: { value: '', keys: ['companyName'] },
      projectStatus: { value: '', keys: ['projectStatus'] },
    },
    count: 0,
    pageSize: 50,
    timeout: null,
    sortBy: '',

    currentLead: {},
  },

  getters: {
    getColumns(state) {
      return state.columns;
    },

    getRows(state) {
      return state.rows;
    },

    getFilters(state) {
      return state.filters;
    },

    lead(state) {
      return state.currentLead;
    },
  },

  mutations: {
    setQuery(state, query) {
      state.query = query;
    },

    updateFilter(state, { fields, type, value }) {
      state.filters[type] = { value: value, keys: fields };
    },

    setContactData(state, data) {
      state.rows = data;
    },

    setCurrentLead(state, data) {
      state.currentLead = data;
    },

    setCount(state, count) {
      state.count = count;
    },

    setSort(state, sortBy) {
      state.sortBy = sortBy;
    },

    updateStatus(state, data) {
      state.currentLead.status = data;
    },

    updateProjectStatus(state, data) {
      state.currentLead.projectStatus = data;
    },

    setActiveLead(state, id) {
      for (let lead of state.rows) {
        if (lead.id === id) {
          state.currentLead = lead;
        }
      }
    },
  },

  actions: {
    sortResults({ commit, dispatch }, sortKey) {
      commit('setSort', sortKey);
      dispatch('fetchLeadsData');
    },
    updateQueryAndFilter({ commit, dispatch, state }, { fields, value, type }) {
      if (type == 'name') {
        commit('setQuery', value);
      }
      commit('updateFilter', { fields, type, value });

      clearTimeout(state.timeout);
      state.timeout = setTimeout(() => {
        dispatch('fetchLeadsData', 1);
      }, 500);
    },

    setLeadDetail({ commit }, data) {
      commit('setCurrentLead', data);
    },

    setActiveLead({ commit }, id) {
      commit('setActiveLead', id);
    },

    async fetchLeadsData({ dispatch, commit, rootState, state }, page = 1) {
      const dirId = rootState[''].ourPublicProfilesDetail.profile.directory;
      let filterQuery =
        '&' +
        Object.keys(state.filters)
          .map(k => k + '=' + encodeURIComponent(state.filters[k].value))
          .join('&');
      return agencyDashboardAPI
        .getLeads(
          dirId,
          page,
          state.pageSize,
          state.query,
          filterQuery,
          state.sortBy
        )
        .then(data => {
          commit('setCount', data.count);
          commit('setContactData', data.results);
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    async updateStatus({ dispatch, commit }, data) {
      return agencyDashboardAPI
        .updateLeadStatus(data.id, { status: data.status })
        .then(() => {
          commit('updateStatus', data.status);
          dispatch('showUserMessage', { ...genericSuccess }, { root: true });
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    async updateProjectStatus({ dispatch, commit }, data) {
      return agencyDashboardAPI
        .updateLeadStatus(data.id, { projectStatus: data.projectStatus })
        .then(() => {
          commit('updateProjectStatus', data.projectStatus);
          dispatch('showUserMessage', { ...genericSuccess }, { root: true });
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },
  },
};
